import { storageGet, storageRemove, storageSet } from '~/shared/lib/storage'

import { BaseAuthStore } from './BaseAuthStore'

type FallbackToken = string | null
type FallbackPhone = string | null
/**
 * The default auth store for browsers with auto fallback
 * to runtime/memory if local storage is undefined (eg. in node env).
 */
export class LocalAuthStore extends BaseAuthStore {
  private readonly storageKeyToken: string
  private readonly storageKeyPhone: string

  private fallbackToken: FallbackToken = null
  private fallbackPhone: FallbackPhone = null

  constructor(storageKeyToken: string, storageKeyPhone: string) {
    super()

    this.storageKeyToken = storageKeyToken
    this.storageKeyPhone = storageKeyPhone
  }

  get token(): string {
    const storageByKey = storageGet<string>(this.storageKeyToken)
    return storageByKey || this.fallbackToken || ''
  }
  get phone(): string {
    const storageByKey = storageGet<string>(this.storageKeyPhone)
    return storageByKey || this.fallbackPhone || ''
  }

  saveToken(token: string) {
    const { isMemoryUpdate } = storageSet<string>(this.storageKeyToken, token)

    if (isMemoryUpdate) {
      this.fallbackToken = token
    }

    super.saveToken(token)
  }
  savePhone(phone: string) {
    const { isMemoryUpdate } = storageSet<string>(this.storageKeyPhone, phone)

    if (isMemoryUpdate) {
      this.fallbackPhone = phone
    }

    super.savePhone(phone)
  }

  clearToken() {
    storageRemove(this.storageKeyToken)
    this.fallbackToken = null
    super.clearToken()
  }

  clearPhone() {
    storageRemove(this.storageKeyPhone)
    this.fallbackPhone = null
    super.clearPhone()
  }
}
